import React from 'react';
import { Button, Dropdown, Input, Form, TextArea } from 'semantic-ui-react';
import $ from "jquery";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';

class Items extends React.Component {

  state = {

  }

  componentDidMount() {
    let context = this;
    $("#remark"+context.props.id).keyup(function(event) {
      if (context.props.lastArrayId == context.props.id) {
        if (event.keyCode === 13) {
          context.props.addItem();
        }
      }
    });
    $("#part"+this.props.lastArrayId).focus();
  }

  partcode = event => {
    let value = event.target.value;
    let brand = value.split('->')[2];
    value = value.split('->')[0];
    this.setState({ partcode: value });
    this.props.updateItem(value, brand, this.props.id, event.target.value);
  }

  onChanges = (type) => (f, { value }) => {
    if (type == 'branch_stock') {
      if (0 > value) {
        document.getElementById('stock'+this.props.id).value = '';
        alert('Your enter Negative value');
        return;
      }
    }
    this.props.updateStock(this.props.id, type, value);
  }

  remove(id) {
    this.props.remove(id);
  }

  render() {
    let closingStock = this.props.item.closing;
    let branchStock = this.props.item.branch_stock;
    try {
      closingStock = Number(closingStock);
      branchStock = Number(branchStock);
    } catch (e) {

    }
    return (
      <tbody>
        <tr style={{backgroundColor: this.props.item.color}}>
          <td rowspan="2"><center>{this.props.sino}</center></td>
          <td style={{width: '40%'}}>
          <center>
          <datalist id="suggestions">
              {this.props.spareOption.map((x) => {
                return (
                  <option id='box'>{x.text}</option>
                )
              })}
          </datalist>
          <input style={{height: 35, width: '100%'}} onChange={this.partcode} autoComplete="on"
          list="suggestions" value={this.props.item.dropdownvalue} id={"part"+this.props.id} />
          </center>
          </td>
          <td><center>{this.props.item.brand_id+"->"+this.props.item.brand_name}</center></td>
          <td><center>{this.props.item.closing}</center></td>
          <td><center><Input fluid type="number" id={'stock'+this.props.id} value={this.props.item.branch_stock} onChange={this.onChanges('branch_stock')} /></center></td>
          <td><center>{branchStock - closingStock}</center></td>
          <td style={{cursor: 'pointer'}} onClick={this.remove.bind(this, this.props.id)}><center>Remove</center></td>
        </tr>
        <tr style={{backgroundColor: this.props.item.color}}>
          <td colspan="6">
            <center>
              <Form>
                <Input value={this.props.item.remark} fluid placeholder='Remark'
                onChange={this.onChanges('remark')} id={"remark"+this.props.id} />
              </Form>
            </center>
          </td>
          <td colspan="2" style={{display: 'none'}}>
            <Input value={this.props.item.voucher} fluid placeholder='Voucher'
            onChange={this.onChanges('voucher')} id={"voucher"+this.props.id} />
          </td>
        </tr>
      </tbody>
    );
  }
}

export default Items;
